import { lazy, Suspense } from "react";

const SubscriptionPlans = lazy(() => import("./components/SubscriptionPlans"));

export default function SubscriptionPage() {

  return (
    <Suspense fallback={
      <div className="flex justify-center py-20">
        <div className="flex items-center gap-3 text-[#0859B8]">
          <div className="animate-spin rounded-full h-6 w-6 border-2 border-[#0859B8] border-t-transparent"></div>
          <span className="font-heading font-bold text-[#222222]">Loading plans...</span>
        </div>
      </div>
    }>
      <SubscriptionPlans />
    </Suspense>
  );

}